import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fechamento-faa`

    return {
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        procedimento(queryParms) {

            return repository.get(`${baseUrl}/procedimento?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        cancelarFaa(id, params) {
            return repository.put(`${baseUrl}/cancelar-faa/${id}`, params)
        },
    }
}